import { Link } from "react-router-dom";

import { Space, Breadcrumb, Button } from "antd";
import type { ColumnsType } from "antd/es/table";
import { PageHeader } from "@ant-design/pro-layout";

import type { GetPageCallbackFunc } from "../../components/DataTable";
import DataTable from "../../components/DataTable";
import SessionStore from "../../model/SessionStore";

import {Site} from "../../model/model";

function ListSites() {
  const columns: ColumnsType<Site> = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => <Link to={`/site/${record.id}/edit`}>{text}</Link>,
    },
  ];

  const getPage = (limit: number, offset: number, callbackFunc: GetPageCallbackFunc) => {
   
    SessionStore.getClient().getAllSites(SessionStore.getBearer()).then((resp) => {
      const obj = resp.data;;
      callbackFunc(obj.length, obj);
    });
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Network Server</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Sites</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title="Sites"
        extra={[
          <Button type="primary">
            <Link to="/sites/create">Add site</Link>
          </Button>,
        ]}
      />
      <DataTable columns={columns} getPage={getPage} rowKey="id" />
    </Space>
  );
}

export default ListSites;
